import { generatePath } from 'react-router';
import useCompanyId from '@/Hooks/UseCompanyId';

function useCompanyIdRoute(route: string) {
    const companyId = useCompanyId();
    const url = generatePath(route, { companyId });
    return url;
}

function useCompanyIdAndClientIdRoute(route: string, clientId: string) {
    const companyId = useCompanyId();
    const url = generatePath(route, { companyId, clientId });
    return url;
}

export { useCompanyIdRoute, useCompanyIdAndClientIdRoute };
